import axios from '../axios'

const deleteLessonApi = async (lessonId) => {
  return await axios.delete(`api/lms/lessons/${lessonId}`)
}

export default deleteLessonApi
